/*
src/ui-panels/SkyPanel.js
wgbh-skydiagram-testing
astro.unl.edu
2019-06-18
*/


import * as React from 'react';

import {FormGroup, Slider, Callout, H4} from '@blueprintjs/core';

import {ColorPicker} from '../ui-misc/ColorPicker.js';


export class SkyPanel extends React.Component {


	constructor(props) {
		super(props);

		// Params are specific properties of the ParamsManager that use the getParams and setParams methods.
		// The paramsOfInterest object is used to fetch only the params used by this panel.
		// The propertiesOfInterest array includes the names of all params of interest, plus any additional
		//	properties of interest that are not params. It is used to determine if the panel needs to be re-rendered.
		// Examples: width is a param, but sunImage is not. Both are properties.
		this._paramsOfInterest = {darkestShadingLevel: null, shadingLevelTransitionPower: null,
															skyTransitionBelowThreshold: null, skyTransitionAboveThreshold: null,
															skyLevelTransitionPower: null,
															dayTopColor: null, dayBottomColor: null,
															nightTopColor: null, nightBottomColor: null};
		this._propertiesOfInterest = [];
		for (const key in this._paramsOfInterest) {
			this._propertiesOfInterest.push(key);
		}

		this.forceRender = this.forceRender.bind(this);
		this.paramsManagerChangeCallback = this.paramsManagerChangeCallback.bind(this);
		this.handleSetParams = this.handleSetParams.bind(this);

		this._paramsMan = this.props.workspace.getParamsManager();

		this._paramsMan.registerCallback('change', this.paramsManagerChangeCallback);

		this.state = {
			dirtyCount: 1,
		};
	}


	forceRender() {
		this.setState(state => ({dirtyCount: state.dirtyCount+1}));
	}

	paramsManagerChangeCallback(type, caller, data) {
		// Re-render only if any of the properties of interest have changed.
		for (const key of this._propertiesOfInterest) {
			if (data.newValues.hasOwnProperty(key)) {
				this.forceRender();
				return;
			}
		}
	}

	handleSetParams(p) {
		this._paramsMan.setParams(p);
	}


	render() {

		let params = this._paramsMan.getParams(this._paramsOfInterest);

		return (
			<div style={{maxWidth: "750px", margin: "30px auto"}}>

				<ColorPicker label="Daytime Sky Top Color"
					color={params.dayTopColor} allowAlpha={false}
					onChange={value => this.handleSetParams({dayTopColor: value})} />

				<ColorPicker label="Daytime Sky Bottom Color"
					color={params.dayBottomColor} allowAlpha={false}
					onChange={value => this.handleSetParams({dayBottomColor: value})} />
			
				<ColorPicker label="Nighttime Sky Top Color"
					color={params.nightTopColor} allowAlpha={false}
					onChange={value => this.handleSetParams({nightTopColor: value})} />

				<ColorPicker label="Nighttime Sky Bottom Color"
					color={params.nightBottomColor} allowAlpha={false}
					onChange={value => this.handleSetParams({nightBottomColor: value})} />

				<FormGroup label="Sky Transition Below Horizon Threshold" labelFor="sky-transition-below-slider">
					<Slider id="sky-transition-below-slider" min={0.0} max={0.2} stepSize={0.001} labelStepSize={0.02}
						onChange={value => this.handleSetParams({skyTransitionBelowThreshold: value})} value={params.skyTransitionBelowThreshold} />
				</FormGroup>

				<FormGroup label="Sky Transition Above Horizon Threshold" labelFor="sky-transition-above-slider">
					<Slider id="sky-transition-above-slider" min={0.0} max={0.2} stepSize={0.001} labelStepSize={0.02}
						onChange={value => this.handleSetParams({skyTransitionAboveThreshold: value})} value={params.skyTransitionAboveThreshold} />
				</FormGroup>

				<FormGroup label="Sky Level Transition Response" labelFor="sky-level-transition-power-slider">
					<Slider id="sky-level-transition-power-slider" min={1} max={10.0} stepSize={0.01} labelStepSize={1.0}
						onChange={value => this.handleSetParams({skyLevelTransitionPower: value})} value={params.skyLevelTransitionPower} />
				</FormGroup>	

				<FormGroup label="Nighttime Shading Level" labelFor="darkest-shading-level-slider">
					<Slider id="darkest-shading-level-slider" min={0.0} max={1.0} stepSize={0.001} labelStepSize={0.1}
						onChange={value => this.handleSetParams({darkestShadingLevel: value})} value={params.darkestShadingLevel} />
				</FormGroup>

				<FormGroup label="Nighttime Shading Transition Response" labelFor="shading-level-transition-power-slider">
					<Slider id="shading-level-transition-power-slider" min={1} max={10.0} stepSize={0.01} labelStepSize={1.0}
						onChange={value => this.handleSetParams({shadingLevelTransitionPower: value})} value={params.shadingLevelTransitionPower} />
				</FormGroup>	

			</div>
		);
	}

}


